import { render, staticRenderFns } from "./icon-picker.vue?vue&type=template&id=6caf55a8&scoped=true&"
import script from "./icon-picker.component.ts?vue&type=script&lang=ts&"
export * from "./icon-picker.component.ts?vue&type=script&lang=ts&"
import style0 from "./icon-picker.vue?vue&type=style&index=0&id=6caf55a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6caf55a8",
  null
  
)

export default component.exports